import { debugWarn, debugError } from '../../utils/debugLog';

/**
 * Extract authentication data (groups, role) from JWT token
 *
 * @param {string} token - JWT token string
 * @returns {Object} Object with groups array and role string
 */
export const extractAuthDataFromToken = token => {
  if (!token) {
    return { groups: [], role: 'user' };
  }

  try {
    // Decode JWT payload (base64url decode)
    const parts = token.split('.');
    if (parts.length !== 3) {
      debugWarn('⚠️ Invalid JWT token format');
      return { groups: [], role: 'user' };
    }

    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    );

    return {
      groups: payload.groups || [],
      role: payload.role || 'user',
    };
  } catch (error) {
    debugError('❌ Failed to extract auth data from token:', error);
    return { groups: [], role: 'user' };
  }
};
